export const texts = {
    en: {
        home: {
            seoTitle: "Home | Giffy",
            title: "Last Search",
        },
        Login: {
            title: "Login",
            inputUser: "User name",
            inputPassword: "Password",
            inputSubmit: "Login",
            error: "There was a problem, please try again.",
            register:"You do not have an account?"
        },
        Register: {
            title: "Register"
        },
        FormSearch: {
            placeholder: "Gif ...",
            btnSearch: "Search",
            rating: "Rating type"
        },
        nav: {
            btnLanguage: "Español",
            darkTheme: "Dark Theme",
            lightTheme: "Ligth Theme",
            btnLogin: "Login",
            btnLogout: "Logout",
        }
    },
    es: {
        home: {
            seoTitle: "Inicio | Giffy",
            title:"Última búsqueda",
        },
        Login: {
            title: "Ingresar",
            inputUser: "Nombre de Usuario",
            inputPassword: "Contraseña",
            inputSubmit: "Ingresar",
            error: "Hubo un problema, inténtalo de nuevo.",
            register:"¿No tienes una cuenta?"
        },
        Register: {
            title: "Registro"
        },
        FormSearch: {
            placeholder: "Gif ...",
            btnSearch: "Buscar",
            rating: "Tipo de Rating"
        },
        nav: {
            btnLanguage: "English",
            darkTheme: "Tema Oscuro",
            lightTheme: "Tema Claro",
            btnLogin: "Ingresar",
            btnLogout: "Cerrar sesión",
        }
    },
}